import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Colors, CompoundProps, Sizes } from '@/components/ui/types';

import Fieldset from '../fieldset';
import { CheckboxProps } from './types';

const sizeClasses: Record<Sizes, string> = {
  xs: 'checkbox-xs',
  sm: 'checkbox-sm',
  md: 'checkbox-md',
  lg: 'checkbox-lg',
  xl: 'checkbox-xl',
};

const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'checkbox-neutral',
  primary: 'checkbox-primary',
  secondary: 'checkbox-secondary',
  accent: 'checkbox-accent',
  info: 'checkbox-info',
  success: 'checkbox-success',
  warning: 'checkbox-warning',
  error: 'checkbox-error',
};

const CheckboxBase = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, size = 'md', color = 'default', ...props }, ref) => {
    const classes = twMerge(
      'checkbox',
      sizeClasses[size],
      colorClasses[color],
      className,
    );

    return <input ref={ref} type="checkbox" className={classes} {...props} />;
  },
);

const CheckboxGroup = forwardRef<HTMLDivElement, CompoundProps>(
  ({ children, className, ...props }, ref) => {
    const classes = twMerge('flex flex-col gap-6', className);
    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  },
);

CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxBase.displayName = 'Checkbox';

export const Checkbox = Object.assign(CheckboxBase, {
  Fieldset,
  Group: CheckboxGroup,
});
